/* global mainScript */
import React, { useState, useRef } from "react";
import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";

//style rules
import { Sizes } from "../styles";

const SiteSearch = () => {
	const [isSearchOpen, setIsSearchOpen] = useState(false);
	const inputRef = useRef(null);

	const renderIcon = (icon) => (
		<img
			src={`${mainScript.assetPath}images/svg/icons/icon-${icon}.svg`}
			alt=""
		/>
	);

	const toggleSearch = () => setIsSearchOpen((currentValue) => !currentValue);

	const focusInput = () => inputRef.current.focus();

	return (
		<SearchContainer>
			<Icon
				role={"button"}
				aria-label="Open search input"
				className="icon"
				onClick={toggleSearch}
				tabIndex={0}
			>
				{renderIcon("search-white")}
			</Icon>
			<AnimatePresence>
				{isSearchOpen && (
					<Form
						role="search"
						action="/"
						method="get"
						initial={{ x: "110%" }}
						animate={{ x: 0 }}
						exit={{ x: "120%" }}
						transition={{
							x: { duration: 0.3 },
						}}
						onAnimationComplete={focusInput}
					>
						<InputContainer>
							<InputIcon>{renderIcon("search-black")}</InputIcon>
							<InputLabel>Enter your search</InputLabel>
							<Input
								ref={inputRef}
								type={"text"}
								name="s"
								placeholder="Search"
							/>
							<IconClose
								onClick={toggleSearch}
								aria-label="close search input"
								role={"button"}
								tabIndex={0}
							>
								{renderIcon("close")}
							</IconClose>
						</InputContainer>
					</Form>
				)}
			</AnimatePresence>
		</SearchContainer>
	);
};

export default SiteSearch;

const SearchContainer = styled.div`
	padding: 0 0 2.7rem;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		padding: 0 3.4rem 0;
	}
`;

const Icon = styled.div`
	width: 25.31px;
	height: 25.31px;
	cursor: pointer;
`;

const Form = styled(motion.form)`
	width: 100%;
	position: absolute;
	right: 0px;
	top: -18px;
	z-index: 11;
	height: 118px;
	align-items: baseline;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		width: 745px;
		top: 28px;
		right: 0;
	}
`;

const InputContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	position: relative;
`;

const Input = styled.input`
	height: 61px;
	padding: 0.8rem 0.8rem 0.8rem 6rem !important;
	border-radius: 4px !important;
	margin-bottom: 0 !important;

	&::placeholder {
		font-size: 1.6rem;
		line-height: 2.7rem;
	}
`;

const InputLabel = styled.label`
	position: absolute;
	top: -22px;
	visibility: hidden;
`;

const InputIcon = styled(Icon)`
	position: absolute;
	left: 20px;
	cursor: default;
`;

const IconClose = styled(Icon)`
	position: absolute;
	right: 20px;
	width: 18px;
	height: 18px;
`;
